import { createMessageStore } from './MessageList.store';

export const messageStore = createMessageStore();
